import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormStepperService, FormValidationService, GeolocationRequestService } from '../../services';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-navigation-buttons',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './navigation-buttons.component.html',
  styleUrls: ['./navigation-buttons.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationButtonsComponent {
  public form = input<FormGroup>();

  
  private _formValidationService = inject(FormValidationService);
  private _formStepperService = inject(FormStepperService);
  private _geolocationRequestService = inject(GeolocationRequestService);
  
  protected currentSlideIndex = this._formStepperService.currentSlideIndex;
  protected canGoPrev = this._formStepperService.canGoPrev;
  protected isLastSlide = this._formStepperService.isLastSlide;
  
  protected canGoNext = computed(() => {
    const form = this.form();
    const currentSlide = this.currentSlideIndex();
    
    if (!form) return false;
    
    const result = this._formValidationService.validateSlide(currentSlide, form, false);
    
    return result.isValid;
  });
  
  // Navigation methods
  protected goToNextSlide(): void {
    this._formStepperService.setIsNextButtonClicked(true);
    
    const form = this.form();
    const currentSlide = this.currentSlideIndex();
    
    if (!form) return;
    
    const validation = this._formValidationService.validateSlide(currentSlide, form, true);
    
    if (!validation.isValid) {
      return;
    }
    
    if (this.isLastSlide()) {
      this.handleLastSlideClick();
      return;
    }
    
    this._formStepperService.goToNext();
    this._resetValidationFlags();
  }
  
  protected goToPrevSlide(): void {
    this._resetValidationFlags();
    this._formStepperService.goToPrev();
  }
  
  protected handleLastSlideClick(): void {
    this._formStepperService.setIsLastSlideValidationActive(true);
    
    const form = this.form();
    const currentSlide = this.currentSlideIndex();
    
    if (!form) return;
    
    const validation = this._formValidationService.validateSlide(currentSlide, form, true);
    
    if (!validation.isValid) {
      return;
    }
    
    this._geolocationRequestService.setIsGeolocationView(true);
    this._formStepperService.triggerFormSubmission();
  }
  
  private _handleGeolocationRequest(): void {
    const geolocationControl = this.form().get('geolocation');
    
    if (geolocationControl) {
      geolocationControl.setValue(true);
      geolocationControl.markAsTouched();
    }
  }

  private _resetValidationFlags(): void {
    this._formStepperService.setIsNextButtonClicked(false);
    this._formStepperService.setIsLastSlideValidationActive(false);
  }
}
